import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-relative not-found-page tw-w-full tw-h-screen tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-8 tw-bg-gray-100 tw-space-y-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 tw-flex tw-flex-col tw-justify-center tw-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-12 tw-py-16 tw-rounded-lg tw-shadow-lg tw-space-y-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "tw-text-5xl" }, "Portal Inactivo"),
    /*#__PURE__*/_createElementVNode("span", { class: "tw-text-3xl" }, "El portal al que intenta acceder se encuentra inactivo.")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}